var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "default-consent-wrapper",
      class: { "consent-entity-border": !_vm.isDetailPage },
      on: {
        click: function($event) {
          return _vm.$emit("click")
        }
      }
    },
    [
      _c(
        "div",
        {
          staticStyle: { display: "flex", "justify-content": "space-between" }
        },
        [
          _c(
            "div",
            {
              staticClass: "cell-header single-line-text",
              class: { "cell-header-detail": _vm.isDetailPage }
            },
            [_vm._v("\n        " + _vm._s(_vm.title) + "\n    ")]
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "date-status-wrapper" }, [
        _c("div", { staticClass: "consent-status", style: _vm.styleColor }, [
          _vm._v("\n        " + _vm._s(_vm.status) + "\n      ")
        ]),
        _vm._v(" "),
        _c("div", {
          staticStyle: { width: "auto", "flex-grow": "1", order: "2" }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "cell-subtext" }, [_vm._v(_vm._s(_vm.date))])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }